import { makeObservable, observable, action } from 'mobx';
import { parseQuery } from '../helpers/parseQuery.js';
import '../enums/GameSpecificTypes.js';
import '../enums/Chat.js';
import '../enums/GameModes.js';
import '../enums/IconTypes.js';
import '../enums/BetStatus.js';
import '../enums/PopupTypes.js';
import '../enums/ApiVersion.js';
import '../enums/RoundStatus.js';
import '../enums/RequestStatus.js';
import '../enums/FreeBetsStatus.js';
import '../enums/SocketEvents.js';
import '../enums/TranslationKeys.js';
import '../enums/ApiServiceTypes.js';
import '../enums/EnvironmentTypes.js';
import { DefaultQueryParams } from '../enums/DefaultQueryParams.js';
import '../enums/BetHistoryFilterTypes.js';
import '../enums/GameThemeTypes.js';
import '../enums/FetchDefaultPaths.js';
import '../enums/ResponseCodes.js';
import '../../../moment-27179cac.js';
import '../../../tslib.es6-80f01feb.js';
import '../../../_commonjsHelpers-4c2b67c2.js';

var GameConfigStore = /** @class */ (function () {
    function GameConfigStore() {
        this.limits = {};
        this.gameConfiguration = {};
        this._gameTypeId = null;
        this._gameId = null;
        makeObservable(this, {
            limits: observable.deep,
            _gameTypeId: observable,
            _gameId: observable,
            gameConfiguration: observable.deep,
            setLimits: action.bound,
            setGameConfiguration: action.bound,
            setGameTypeId: action.bound,
            setGameId: action.bound,
        });
    }
    GameConfigStore.prototype.setLimits = function (limits) {
        this.limits = limits;
    };
    GameConfigStore.prototype.setGameConfiguration = function (gameConfiguration) {
        this.gameConfiguration = gameConfiguration;
    };
    GameConfigStore.prototype.setGameTypeId = function (id) {
        this._gameTypeId = id;
    };
    Object.defineProperty(GameConfigStore.prototype, "gameTypeId", {
        get: function () {
            return this._gameTypeId || parseQuery(window.location.search)[DefaultQueryParams.GameTypeId];
        },
        enumerable: false,
        configurable: true
    });
    GameConfigStore.prototype.setGameId = function (id) {
        this._gameId = id;
    };
    Object.defineProperty(GameConfigStore.prototype, "gameId", {
        get: function () {
            return this._gameId || parseQuery(window.location.search)[DefaultQueryParams.GameId];
        },
        enumerable: false,
        configurable: true
    });
    return GameConfigStore;
}());
var gameConfigStore = new GameConfigStore();

export { GameConfigStore, gameConfigStore };
